export default __webpack_public_path__ + "static/media/freelanser classy1.b28076ce.png";